import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { UseSupplierOffer } from "./UseSupplierOffer";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toMoney } from "../../util/Utils";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import LastOrderDetail from "./LastOrderDetail";

export default function OfferDetail(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { getOfferByID } = UseSupplierOffer();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const [lastOrder, setLastOrder] = useState();

  const [state, setState] = useState({
    productID: undefined,
    product: undefined,
    operator: undefined,
    product: undefined,
    productCount: undefined,
    requestCount: undefined,
    productURL: undefined,
    supplier: undefined,
    shamsiLogdate: undefined,
    shamsiOperatorLogdate: undefined,
    stateTitle: undefined,
    description: undefined,
  });

  useEffect(() => {
    if (props.offerID) {
      setProgress(true);
      getOfferByID(props.offerID, (supplierRes) => {
        setState({
          id: supplierRes.id,
          productID: supplierRes.productID,
          operator: supplierRes.operator,
          product: supplierRes.product,
          productURL: supplierRes.productURL,
          productCount: supplierRes.productCount,
          requestCount: supplierRes.requestCount,
          visitorMobile: supplierRes.visitorMobile,
          supplier: supplierRes.supplier,
          visitor: supplierRes.visitor,
          shamsiLogdate: supplierRes.shamsiLogdate,
          shamsiOperatorLogdate: supplierRes.shamsiOperatorLogdate,
          stateTitle: supplierRes.stateTitle,
          description: supplierRes.description,
          lastOrder: supplierRes.lastOrder,
        });
      });
    }
  }, [props.offerID]);

  return (
    <Dialog
      BackdropProps={{
        style: {
          // backgroundColor: "transparent",
        },
      }}
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      maxWidth="md"
      open={props.open.show}
      onClose={() => props.setOpen({ ...props.open, show: false })}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {!lastOrder ? (
              <Typography color="primary" variant="subtitle1">
                جزئیات پیشنهاد
              </Typography>
            ) : (
              <Typography color="primary" variant="subtitle1">
                جزئیات سفارش آخر
              </Typography>
            )}
            {!lastOrder ? (
              <IconButton
                onClick={() => props.setOpen({ ...props.open, show: false })}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            ) : (
              <IconButton
                onClick={() => {
                  setLastOrder(false);
                }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
          {!lastOrder ? (
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.supplier ? state.supplier : "-"}
                  label="تامین کننده"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.visitor ? state.visitor : "-"}
                  label="ویزیتور"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.visitorMobile ? state.visitorMobile : "-"}
                  label="شماره ویزیتور"
                  fullWidth
                  sx={{ input: { direction: "rtl" } }}
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={3}>
                <TextField
                  value={state.productID ? state.productID : "-"}
                  label="کد محصول"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  sx={{ input: { direction: "rtl" } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={9}>
                <TextField
                  value={state.product ? state.product : "-"}
                  label="محصول"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            window.open(state.productURL, "_blank")
                          }
                          sx={{ mx: 1 }}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.productCount ? toMoney(state.productCount) : "-"}
                  label="تعداد پیشنهادی"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  sx={{ input: { direction: "rtl" } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.requestCount ? toMoney(state.requestCount) : "-"}
                  label="تعداد درخواستی"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  sx={{ input: { direction: "rtl" } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.operator ? state.operator : "-"}
                  label="اپراتور"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.shamsiLogdate ? state.shamsiLogdate : "-"}
                  label="تاریخ پیشنهاد"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  sx={{ input: { direction: "rtl" } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={
                    state.shamsiOperatorLogdate
                      ? state.shamsiOperatorLogdate
                      : "-"
                  }
                  label="تاریخ بررسی"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  sx={{ input: { direction: "rtl" } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.stateTitle ? state.stateTitle : "-"}
                  label="وضعیت"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={6}>
                <TextField
                  value={state.description ? state.description : "-"}
                  label="توضیحات"
                  fullWidth
                  multiline
                  rows={3}
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={6}>
                <TextField
                  value={
                    state.lastOrder && state.lastOrder.shamsiLogdate
                      ? state.lastOrder.shamsiLogdate
                      : "-"
                  }
                  label="تاریخ آخرین سفارش"
                  fullWidth
                  sx={{ input: { direction: "rtl" } }}
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button
                          sx={{
                            display: state.lastOrder?.id ? "flex" : "none",
                          }}
                          variant="outlined"
                          onClick={() => setLastOrder(true)}
                        >
                          جزئیات
                        </Button>
                        {/* <IconButton
                          onClick={() =>
                            window.open(state.productURL, "_blank")
                          }
                          sx={{ mx: 1 }}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton> */}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <LastOrderDetail orderID={state.lastOrder.id} />
          )}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={() => props.setOpen({ ...props.open, show: false })}
              variant="outlined"
            >
              بستن
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
